module.exports = __webpack_public_path__ + "media/images/help/browse_img_3-66c521087b0211ae44ba71f10375ba44.jpeg";